import React from "react";
import s from "./InsuranceCompanies.module.scss";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import { Table } from "antd";
import { Link } from "react-router-dom";
import { DownloadOutlined, FilePdfOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { getVacancyDetails } from "../../redux/ApplicationSlice";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimensions/WindowDimensions";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";
import { useTranslation } from "react-i18next";

const InsuranceCompanies = () => {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const { t } = useTranslation();
  const insuranceCompanies = useSelector(
    (state) => state.application.insuranceCompanies
  );

  const columns = [
    {
      title: "№",
      dataIndex: "number",
      width: 20,
      align: "center",
    },
    {
      title: t("accreditedInsuranceCompanies"),
      dataIndex: `appriser`,
      width: 400,
    },
    {
      title: t("contacts"),
      dataIndex: `contacts`,
      width: 600,
    },
  ];

  const downloadFile = async () => {
    const fileUrl =
      "/assets/appendix/Приложение №1 Критерии аккредитации страховых компаний.pdf";
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download =
      "Приложение №1 Критерии аккредитации страховых компаний.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openFileInNewWindow = (e, file) => {
    e.preventDefault();
    const fileUrl = file;
    window.open(fileUrl, "_blank");
  };

  return (
    <div>
      {width > 930 ? <Header /> : <MobileHeader />}
      <div className={s.content}>
        <div className={s.documents_btns}>
          <div className={s.documents_item}>
            <button
              className={s.title}
              onClick={(e) =>
                openFileInNewWindow(
                  e,
                  "/assets/appendix/Приложение №1 Критерии аккредитации страховых компаний.pdf"
                )
              }
            >
              <FilePdfOutlined className={s.icon} /> &nbsp;
              {t("CriteriaforSelectingInsuranceCompanies")}
            </button>
            <div className={s.btn} onClick={() => downloadFile()}>
              <DownloadOutlined className={s.icon} />
            </div>
          </div>
          <div className={s.documents_item}>
            <Link
              to='/vacancies/5'
              className={s.title}
              onClick={() => dispatch(getVacancyDetails(5))}
            >
              &nbsp;
              <FilePdfOutlined className={s.icon} /> &nbsp;
              {t("Объявление о наборе страховых компаний")}
            </Link>
          </div>
        </div>
        <h2 className={s.h2}>{t("accreditedInsuranceCompanies")}</h2>
        <Table
          bordered
          pagination={false}
          columns={columns}
          dataSource={insuranceCompanies?.map((it, index) => ({
            number: `${index + 1}.`,
            appriser: it?.description,
            contacts: (
              <div>
                <div className={s.contactsItem}>
                  <div className={s.contactTitle}>{t("phone")}:</div>
                  <div>{it?.phone}</div>{" "}
                </div>
                {it?.address ? (
                  <div className={s.contactsItem}>
                    <div className={s.contactTitle}>{t("address")}:</div>
                    <div>{it?.address}</div>
                  </div>
                ) : null}

                <div className={s.contactsItem}>
                  <div className={s.contactTitle}>Email:</div>{" "}
                  <a href={`mailto:${it?.email}`} className={s.site}>
                    {it?.email}
                  </a>
                </div>
                {it.website ? (
                  <div className={s.contactsItem}>
                    <div className={s.contactTitle}>{t("website")}:</div>
                    <Link to={`${it?.website}`} className={s.site}>
                      {it?.website}
                    </Link>
                  </div>
                ) : null}
              </div>
            ),
          }))}
          className='appriser_table'
        />
      </div>

      {/* <div className={s.documents_btns}>
        <Link
          to='/vacancies/2'
          className={s.title}
          onClick={() => dispatch(getVacancyDetails(2))}
        >
          <FilePdfOutlined className={s.icon} /> &nbsp; ОБЪЯВЛЕНИЕ О НАБОРЕ
          НЕЗАВИСИМЫХ ОЦЕНЩИКОВ
        </Link>
      </div> */}

      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default InsuranceCompanies;
